const getContentRoot = (state,) => state.content

// eslint-disable-next-line max-len
export const getContentLoadingSelector = (state,) => getContentRoot(state,).loading
